import { axiosInstance } from "@/services/axiosInstance";

export const getCefDashboard = async (
  startDate: Date,
  endDate: Date,
  corbanId: number,
  promoterId: number,
  commercialManagerId?: string,
  sellerId?: string
) => {
  try {
    const response = await axiosInstance.get("/api/dashboard-bi/cefDashboard", {
      params: {
        startDate,
        endDate,
        corbanId,
        promoterId,
        commercialManagerId,
        sellerId,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar dados do Dashboard CEF:", error);
    return null;
  }
};
